import React from 'react'

export default function Footer1() {
    return (
        <>
        <div className='bg-black text-white '>

            <div className='w-full border border-gray-200 border-b-[1px]'></div>
            <h1 className='text-center py-6 '>COPYRIGHT 2024 &#169; HOMELAND ALL RIGHTS RESERVED</h1>
        </div>
        </>
    )
}
